import React from "react";
import { FormLabel } from "@mui/material";
import axios from "axios";
import { withStyles } from "tss-react/mui";
import { connect } from "react-redux";
import { Link } from "react-router";
import profileIndexStyle from "../../assets/jss/material-dashboard-pro-react/views/profileStyle";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import SweetAlert from "react-bootstrap-sweetalert";

class Index extends React.Component {
  state = {
    totpResetAlert: false,
    totpUntrustAlert: false,
  };

  toggleReset2FA = (e) => {
    e.preventDefault();

    this.setState({ totpResetAlert: !this.state.totpResetAlert });
  };

  toggleUntrustDevice = (e) => {
    e.preventDefault();

    this.setState({ totpUntrustAlert: !this.state.totpUntrustAlert });
  };

  handleReset2FA = () => {
    let data = [];
    const _token = document.head.querySelector('meta[name="csrf-token"]').content;
    data.push("_token", _token);

    axios.post("/core/2fa/reset", data).then((response) => {
      window.location.href = "/manager/2fa";
    });
  };

  handleUntrustDevice = () => {
    axios.post("/core/2fa/untrust-device").then((response) => {
      this.setState({ totpUntrustAlert: false });
      location.reload();
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.totpResetAlert ? (
          <SweetAlert
            cancelBtnCssClass={classes.button + " " + classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={classes.button + " " + classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.toggleReset2FA}
            onConfirm={this.handleReset2FA}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <TranslationWrapper tDefault={"Are you sure you wish to Reset your 2FA?"} tKey={"totp.reset.confirm"} />
            }
            warning
          />
        ) : (
          ""
        )}

        {this.state.totpUntrustAlert ? (
          <SweetAlert
            cancelBtnCssClass={classes.button + " " + classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={classes.button + " " + classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.toggleUntrustDevice}
            onConfirm={this.handleUntrustDevice}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <TranslationWrapper
                tDefault={"Are you sure you wish to untrust this device?"}
                tKey={"totp.untrust.confirm"}
              />
            }
            warning
          />
        ) : (
          ""
        )}

        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Profiel"} tKey={"profiel.pagetitle"} />} />
        <Card>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Accountgegevens"} tKey={"profiel.algemeen"} />
                </h3>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={1} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Gebruikersnaam"} tKey={"profiel.username"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={11} xs={12}>
                {this.props.user.username}
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={1} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Email"} tKey={"profiel.email"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={11} xs={12}>
                {this.props.user.email}
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={1} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Wachtwoord"} tKey={"profiel.password"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={11} xs={12}>
                <Link to={"profiel/password-change"}>
                  <TranslationWrapper tDefault={"verander wachtwoord"} tKey={"profiel.password-change"} />
                </Link>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={1} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Reset 2FA"} tKey={"totp.profile.reset.label"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={11} xs={12}>
                <a href={"#0"} onClick={this.toggleReset2FA}>
                  <TranslationWrapper tDefault={"New 2FA setup"} tKey={"totp.profile.reset.link"} />
                </a>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={1} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Untrust"} tKey={"totp.profile.untrust.label"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={11} xs={12}>
                <a href={"#0"} onClick={this.toggleUntrustDevice}>
                  <TranslationWrapper tDefault={"Untrust 2FA on this device"} tKey={"totp.profile.untrust.link"} />
                </a>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, null)(withStyles(Index, profileIndexStyle));
